import { render, staticRenderFns } from "./expert_consult.vue?vue&type=template&id=5ae3c048&"
import script from "./expert_consult.vue?vue&type=script&lang=js&"
export * from "./expert_consult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports